// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wj","emblaSlide":"wk","textActive":"wl"};